import React, { useMemo, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Keep worker version aligned with installed pdfjs-dist used by react-pdf.
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const normalizePdfSource = file => {
  if (!file || typeof file !== 'string') return '';
  const trimmedFile = file.trim();
  if (!trimmedFile) return '';

  if (
    trimmedFile.startsWith('data:application/pdf;base64,') ||
    trimmedFile.startsWith('blob:') ||
    /^https?:\/\//i.test(trimmedFile)
  ) {
    return trimmedFile;
  }

  return `data:application/pdf;base64,${trimmedFile}`;
};

const PdfPreview = ({ file }) => {
  const source = useMemo(() => normalizePdfSource(file), [file]);
  const [numPages, setNumPages] = useState(0);
  const [error, setError] = useState('');

  const onDocumentLoadSuccess = ({ numPages: totalPages }) => {
    setNumPages(totalPages);
    setError('');
  };

  const onDocumentLoadError = () => {
    setNumPages(0);
    setError('Failed to load PDF file.');
  };

  if (!source) {
    return <div className="text-color-error">Unable to preview file.</div>;
  }

  return (
    <div className="docContainer">
      <Document
        file={source}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={<div>Loading PDF...</div>}
      >
        {error ? (
          <div className="text-color-error">{error}</div>
        ) : (
          Array.from({ length: numPages }, (_, index) => (
            <div key={`page_${index + 1}`} className="docview">
              <Page
                pageNumber={index + 1}
                width={Math.floor(window.innerWidth * 0.75)}
                className="pageView"
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
              {index < numPages - 1 && <hr className="borderDoc" />}
            </div>
          ))
        )}
      </Document>
    </div>
  );
};

export default PdfPreview;